function isRequestFromChina() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (timeZone === 'Asia/Shanghai') {
        return true;
    }

    return false;
}

export default isRequestFromChina;
